<template>
    <div class="modal-content">
        <div>
            <h3 slot="header">{{componentprops.header}}</h3>
        </div>
        <div class="modal-button">
            <button class="button-box-element btn-agree" @click="$emit('agree')" >{{componentprops.btnPrimary}}</button>
            <button class="button-box-element btn-disagree" @click="$emit('disagree')" >{{componentprops.btnSecondary}}</button>
        </div>
    </div>
</template>
<script>

export default {
	name: "warningModal",
	props: ['componentprops'],
	data() {
		return {
            
		}
	},
	methods: {
	}
}
</script>

<style scoped>
    .modal-button {
        display: flex;
        justify-content: space-between;
    }
    .button-box-element {
        width: 130px;
        background-color: #1B608C;
        color: #FFFFFF;
        height: 28px;
        width: 150px;
        border-radius: 28px;
        border: none;
        margin-top: 8px;
    }
    .button-box-element:hover {
        cursor: pointer;
    }
    .btn-agree {
        background-color: #1B608C;

    }
    .btn-disagree {
        background-color: #ECEDF0;
        color: black;
    }
    .btn-disagree:hover {
        background-color: #E16369;
        color: white;
    }
    button {
        font-family: 'Yantramanav', Verdana, Arial, Helvetica, sans-serif;
    }
</style>